import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { NgStyle } from '@angular/common';

Chart.register(...registerables);

@Component({
    selector: 'app-score-question-bar-chart',
    templateUrl: './score-question-bar-chart.component.html',
    styleUrl: './score-question-bar-chart.component.scss',
    imports: [NgStyle]
})
export class ScoreQuestionBarChartComponent implements OnInit {
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  private chartInstance: Chart | any;

  @Input('chartData') 
  set chartData(value) {
    this.labels = value?.labels;
    this.dataSet = value?.dataset;
    this.labelsName = value?.labelsName;
    this.labelsSynonyms = value?.labelsSynonyms;
    if(this.dataSet && this.dataSet.length > 0 &&  this.dataSet[0]) {
      this.data = this.dataSet[0]?.data;
      this.colorCode = this.dataSet[0]?.backgroundColor;
    }
    this.showChart();
  }

  labels: any = [];
  dataSet: any = [];
  labelsName: any = [];
  labelsSynonyms: any = [];
  data: any = [];
  colorCode: any = [];

  tooltipHeading: string = '';
  tooltipColorBoxColorCode: string = '';
  tooltipLabelSynonyms: string = '';
  tooltipCount: any = '';

  event: any = {};
  previousTime: any = '';
  tooltipX: any = '';
  tooltipY: any = '';
  tooltipVisible: any = '';

  constructor(private responseAnalyticsService: ResponseAnalyticsService) {}

  ngOnInit(): void {
    this.showChart();
  }

  private showChart(): void {
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (ctx) {
      this.destroyChart();
      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.labels,
          datasets: this.dataSet,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              ticks: {
                maxTicksLimit: 6,
                stepSize: 1
              }
            },
            x: {
              grid: {
                display: true,
                lineWidth: 0,
                drawOnChartArea: false,
                color: function(context) {
                  return 'rgba(255, 255, 255, 0)'
                }
              },
              stacked: true,
              title: {
                display: true,
                font: {
                  size: 14,
                  family: 'Lato',
                },
                text: 'Rating',
                padding: {
                  bottom: 0,
                }
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          }
        },
      })
    }
    this.chartInstance.canvas.addEventListener('mousemove', (event) => {
      const chartArea = this.chartInstance.chartArea;
      const mouseX = event.offsetX;
      const mouseY = event.offsetY;
      if (mouseX >= chartArea.left && mouseX <= chartArea.right && mouseY >= chartArea.top && mouseY <= chartArea.bottom) {
        const nearestIndex = Math.floor((mouseX - chartArea.left) / (chartArea.right - chartArea.left) * this.labels.length);
        if (nearestIndex >= 0 && nearestIndex < this.labels.length) {
          const obj = {
            index: nearestIndex,
            time: new Date().getTime()
          };
          this.event = obj;
          this.tooltipVisible = 'block';
        }
      } else {
        this.tooltipVisible = 'none';
      }
    });
  }

  @HostListener('document:mousemove', ['$event'])
    onMouseMove(event: MouseEvent): void {
      const screenWidth = window.innerWidth;
      if((screenWidth / 2) > event.offsetX) {
        this.tooltipX = event.offsetX + 15;
      } else {
        this.tooltipX = event.offsetX - 250;
      }
      this.tooltipY = event.offsetY + 10;
      if (this.previousTime !== this.event?.time && this.event?.time) {
        this.previousTime = this.event?.time;
        this.tooltipVisible = 'block';
      } else {
        this.tooltipVisible = 'none';
      }
      this.tooltipHeading = `${this.labelsName[this.event.index]} (${this.labels[this.event?.index]})`;
      this.tooltipColorBoxColorCode = this.colorCode[this.event?.index];
      this.tooltipLabelSynonyms = this.labelsSynonyms[this.event?.index];
      this.tooltipCount = this.responseAnalyticsService.formatNumber(this.data[this.event?.index]);
    }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }
}